import { FilterToolComponent } from '@/app/components/global/filter-tool/filter-tool.component';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { RequestedIttInterface } from '../../../../../interfaces/requested-itt-interface';
import { RfpLabelService } from '../../../project-development/tendering/inivitation-to-tender/rfp-labels.service';

@Component({
  selector: 'app-requested-itt',
  standalone: true,
  imports: [CommonModule, FilterToolComponent, MatMenuModule],
  templateUrl: './requested-itt.component.html',
  styleUrls: ['./requested-itt.component.css'],
})
export class RequestedIttComponent implements OnInit {
  data: RequestedIttInterface[] = [];
  projectId: number | string;
  projectName: string;
  projectIdentifier: string;
  isRFPorRFQ: string;
  labels: any;
  
  constructor(
    private router: Router,
    private TenderingService: TenderingService,
    private getProjectIdService: GetProjectIdService,
    private activeRoute: ActivatedRoute,
    private rfpLabelService: RfpLabelService
  ) {}
  ngOnInit() {
    // Subscribe to route changes
    this.activeRoute.url.subscribe(() => {
      this.updateRFPorRFQFlag();
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.projectId = this.getProjectIdService.getProjectId();
    this.fetchListing();
    this.activeRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
  }
  updateRFPorRFQFlag() {
    const currentRoute = this.router.url.toLowerCase(); // Get full URL path
    if(currentRoute.includes('rfp')){
      this.isRFPorRFQ = 'RFP';
    }else if(currentRoute.includes('rfq')){
      this.isRFPorRFQ = 'RFQ'
    }
    console.log('isRFPorRFQ:', this.isRFPorRFQ);
  }

  navigateToDetailPage(id: number) {
    if(this.isRFPorRFQ === 'RFP'){
      this.router.navigate([`/projects/${this.projectId}/rfp/${id}/show`],{
        queryParams:{
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier
        }
      });
    }else if(this.isRFPorRFQ === 'RFQ'){
      this.router.navigate([`/projects/${this.projectId}/rfq/${id}/show`],{
        queryParams:{
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier
        }
      });
    }
  }
  fetchListing() {
    if(this.isRFPorRFQ === 'RFP'){
      this.TenderingService.fetchIttTendererListing('rfp').subscribe({
        next: (response: any) => {
          this.data = response.data;
        },
        error: (error: any) => {
          console.error('Error:', error);
        },
      });
    } else if(this.isRFPorRFQ === 'RFQ'){
      this.TenderingService.fetchIttTendererListing('rfq').subscribe({
        next: (response: any) => {
          this.data = response.data;
        },
        error: (error: any) => {
          console.error('Error:', error);
        },
      });
    }
  }
}
